var ChangePasswordEnum = /* @__PURE__ */ ((ChangePasswordEnum2) => {
  ChangePasswordEnum2["CHANGE_PASSWORD_FORM"] = "change-password--form";
  ChangePasswordEnum2["CHANGE_PASSWORD_INPUT_CURRENT_PASSWORD"] = "change-password--input-current-password";
  ChangePasswordEnum2["CHANGE_PASSWORD_INPUT_NEW_PASSWORD"] = "change-password--input-new-password";
  ChangePasswordEnum2["CHANGE_PASSWORD_INPUT_CONFIRM_NEW_PASSWORD"] = "change-password--input-confirm-new-password";
  ChangePasswordEnum2["CHANGE_PASSWORD_SUBMIT_BUTTON"] = "change-password--submit-button";
  return ChangePasswordEnum2;
})(ChangePasswordEnum || {});
export {
  ChangePasswordEnum
};
